import React from 'react'
import { FaRegFile, FaDownload, FaTimes } from 'react-icons/fa'
import { Box, Heading, Icon, Button, ConfirmButton } from '@/components/lib'

export default function File ({ url, name, displayName, preview, onRemove }) {
  if (!url) return null
  if (preview) {
    return (
      <Box p={2} bg='bg.surface' rounded='md' shadow='md' display='flex' alignItems='center' justifyContent='space-between'>
        <Heading size='xs' alignItems='center' display='flex'><Icon as={FaRegFile} mr={1} /> {displayName}</Heading>
        <Button ml={2} size='sm' download={displayName} colorPalette='blue' as='a' target='_blank' rel='noopener noreferrer' href={url}><Icon as={FaDownload} mr={2} /> Download</Button>
      </Box>
    )
  }
  return (
    <Box display='flex' justifyContent='center'>
      <Box minWidth='200px' maxWidth='400px' bg='bg.surface' p={4} rounded='md' shadow='md' textAlign='center'>
        <Heading size='sm' display='flex' alignItems='center' justifyContent='center'><Icon as={FaRegFile} mr={1} /> {displayName}</Heading>
        <Box display='flex' justifyContent='center' mt={5}>
          <Button colorPalette='blue' as='a' target='_blank' rel='noopener noreferrer' href={url}><Icon as={FaDownload} mr={2} /> Download</Button>
          {onRemove &&
            <ConfirmButton
              header='Really remove this file?'
              trigger={<Button ml={3} variant='ghost'><Icon as={FaTimes} mr={2} /> Remove</Button>}
              onConfirm={onRemove}
            />}
        </Box>
      </Box>
    </Box>
  )
}
